import { BankAccountConfigTypeDocEspecie } from './BankAccountsSettings.types';

export const bankAccountsSettingsTitleDocSpecies: BankAccountConfigTypeDocEspecie[] =
  [
    { code: '01', description: 'Duplicata Mercantil' },
    { code: '02', description: 'Nota promissória' },
    { code: '03', description: 'Nota de seguro' },
    { code: '04', description: 'Duplicata de Serviço' },
    { code: '05', description: 'Recibo' },
    { code: '06', description: 'Letra de Câmbio' },
    { code: '07', description: 'Nota de Débito' },
    { code: '08', description: 'Boleto de Proposta' },
    { code: '09', description: 'Letra de Câmbio' },
    { code: '10', description: 'Warrant' },
    { code: '11', description: 'Cheque' },
    { code: '12', description: 'Cobrança Seriada' },
    { code: '13', description: 'Mensalidade escolar' },
    { code: '14', description: 'Apólice de Seguro' },
    { code: '15', description: 'Documento de Dívida' },
    { code: '16', description: 'Encargos Condominiais' },
    { code: '17', description: 'Conta de prestação de serviço' },
    { code: '18', description: 'Contrato' },
    { code: '19', description: 'Cosseguro' },
    { code: '20', description: 'Duplicata Rural' },
    { code: '21', description: 'Nota Promissória Rural' },
    { code: '22', description: 'Dívida Ativa da União' },
    { code: '23', description: 'Dívida Ativa de Estado' },
    { code: '24', description: 'Dívida Ativa de Município' },
    { code: '25', description: 'Duplicata Mercantil por Indicação' },
    { code: '26', description: 'Duplicata de Serviço por Indicação' },
    { code: '27', description: 'Nota de Crédito Comercial' },
    { code: '28', description: 'Nota de Crédito para Exportação' },
    { code: '29', description: 'Nota de Crédito Industrial' },
    { code: '30', description: 'Nota de Crédito Rural' },
    { code: '32', description: 'Triplicata Mercantil' },
    { code: '33', description: 'Triplicata de Serviço' },
    { code: '34', description: 'Fatura' },
    { code: '35', description: 'Parcela de Consórcio' },
    { code: '36', description: 'Nota Fiscal' },
    { code: '37', description: 'Cédula de Produto Rural' },
    { code: '38', description: 'Cartão de crédito' },
    { code: '39', description: 'Títulos de Terceiros' },
    { code: '40', description: 'Boleto de Depósito e Aporte' },
    { code: '41', description: 'Cédula de Crédito Bancário por Indicação' },
    { code: '42', description: 'Contrato de Câmbio' },
    { code: '43', description: 'Cédula de Crédito Bancário' },
    { code: '44', description: 'Confissão de Dívida' },
    { code: '45', description: 'Contrato de Mútuo' },
    { code: '46', description: 'Recibo de Aluguel (PJ)' },
    { code: '47', description: 'Termo de acordo' },
    { code: '99', description: 'Outros' },
  ];
